import type { SwatchItem } from "./choice";
import { CheckBadge } from "./CheckBadge";

type Props = {
  items: SwatchItem[];
  onSelect: (id: string) => void;
};

export function SwatchRow(props: Props) {
  return (
    <div className="swatch-row">
      {props.items.map((item) => (
        <button
          key={item.id}
          type="button"
          title={item.label}
          aria-label={item.label}
          aria-pressed={item.selected}
          onClick={() => props.onSelect(item.id)}
          className={[
            "swatch-row__button",
            item.selected ? "swatch-row__button--active" : "",
          ]
            .filter(Boolean)
            .join(" ")}
          style={
            item.texture
              ? { backgroundImage: `url(${item.texture})` }
              : { backgroundColor: item.color }
          }
        >
          {item.selected && <CheckBadge className="swatch-row__check" />}
        </button>
      ))}
    </div>
  );
}
